export default __webpack_public_path__ + "static/media/agilna-metodologija.7399570a.gif";